import { isEmpty } from 'lodash';

import { revertPhoneMask } from 'helpers/revert-phone-mask';
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getBillTo = async (pageNumber, pageSize) =>
  axiosGet(`/bill-to?page[number]=${pageNumber + 1}&page[size]=${pageSize}`);

export const showBillTo = async (id) => axiosGet(`/bill-to/${id}`);

export const updateBillTo = async (id, billTo) => {
  const {
    name,
    address,
    city,
    state,
    postalCode,
    country,
    contactFirstName,
    contactLastName,
    contactTitle,
    contactEmail,
    contactPhone,
  } = billTo;

  await axiosPatch(`/bill-to/${id}`, {
    name,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_title: contactTitle,
    contact_email: contactEmail,
    ...(!isEmpty(contactPhone) && {
      contact_phone: revertPhoneMask(contactPhone),
    }),
  });
};

export const createBillTo = async (billTo) => {
  const {
    name,
    address,
    city,
    state,
    postalCode,
    country,
    contactFirstName,
    contactLastName,
    contactTitle,
    contactEmail,
    contactPhone,
  } = billTo;

  await axiosPost('/bill-to', {
    name,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_title: contactTitle,
    contact_email: contactEmail,
    ...(!isEmpty(contactPhone) && {
      contact_phone: revertPhoneMask(contactPhone),
    }),
  });
};

export const deleteBillTo = async (id) => {
  await axiosDelete(`/bill-to/${id}`);
};
